import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import ChannelDetailPage from "./pages/ChannelDetail";
import FeedPage from "./pages/Feed";
import Root from "./pages/Root";
import SearchFeedPage from "./pages/SearchFeed";
import VideoDetailPage from "./pages/VideoDetail";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      { index: true, element: <FeedPage /> },
      { path: "/video/:id", element: <VideoDetailPage /> },
      { path: "/channel/:id", element: <ChannelDetailPage /> },
      { path: "/search/:searchTerm", element: <SearchFeedPage /> },
    ],
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
